// extracted by mini-css-extract-plugin
export default {"full-width":"components-settings-users-subscription-multi-select-module__full-width"};